import { MatrizIdentidadTiposCuestionarios } from './../_models/matriz-identidad-tipos-cuestionarios';
import { AutenticacionService } from './autenticacion.service';
import { AppSettings } from './../../proyect.conf';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MatrizIdentidadTiposCuestionariosService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/matrizIdentidadTiposCuestionarios';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as MatrizIdentidadTiposCuestionarios[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as MatrizIdentidadTiposCuestionarios[] ) );
  }

  listadoPorIdMatrizIdentidad(idMatrizIdentidad: string) {
    return this.httClient.get( this.rutServicio + '/matrizIdentidad/' +  idMatrizIdentidad).pipe( map( res => res as MatrizIdentidadTiposCuestionarios[] ) );
  }

  listadoPorIdMatrizIdentidadHabilitados(idMatrizIdentidad: string) {
    return this.httClient.get( this.rutServicio + '/matrizIdentidad/' +  idMatrizIdentidad + '/enabled').pipe( map( res => res as MatrizIdentidadTiposCuestionarios[] ) );
  }

  listadoPorIdMatrizIdentidadConProducto(idMatrizIdentidad: string) {
    return this.httClient.get( this.rutServicio + '/matrizIdentidad/' +  idMatrizIdentidad + '/matrizIdentidadTiposCuestionariosProductos').pipe( map( res => res as any[] ) );
  }

  listadoPorIdMatrizIdentidadConProductoHabilitados(idMatrizIdentidad: string) {
    return this.httClient.get( this.rutServicio + '/matrizIdentidad/' +  idMatrizIdentidad + '/matrizIdentidadTiposCuestionariosProductos/enabled').pipe( map( res => res as any[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as MatrizIdentidadTiposCuestionarios ) );
  }

  crear( regCrear: MatrizIdentidadTiposCuestionarios ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as MatrizIdentidadTiposCuestionarios ) );
  }

  actualizar( regActualizar: MatrizIdentidadTiposCuestionarios ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( matrizIdentidad: MatrizIdentidadTiposCuestionarios[] ): Observable<MatrizIdentidadTiposCuestionarios[]> {
    matrizIdentidad.map( sa => {
      sa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', matrizIdentidad ).pipe( map( res => res as MatrizIdentidadTiposCuestionarios[] ) );
  }
}
